import { Reveal, Eyebrow, SectionTitle } from "./shared";
import { useSite } from "../../context/SiteContext";
import { imgUrl, optImg } from "../../lib/api";

export default function Outdoor() {
  const { content } = useSite();
  const outdoor = content?.outdoor;
  if (!outdoor) return null;
  const imgs = outdoor.images || [];

  return (
    <section className="py-20 lg:py-28 bg-olivedark relative grain overflow-hidden" data-testid="outdoor-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <Reveal>
            <Eyebrow light>Cerimônias ao ar livre</Eyebrow>
            <SectionTitle light data-testid="outdoor-title">{outdoor.title}</SectionTitle>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="mt-6 text-base sm:text-lg font-light text-cream/80 leading-relaxed" data-testid="outdoor-text">
              {outdoor.text}
            </p>
          </Reveal>
        </div>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-3 gap-5 lg:gap-7">
          {imgs.map((img, i) => (
            <Reveal key={i} delay={i * 0.12} className={i === 1 ? "sm:mt-12" : ""}>
              <div className="overflow-hidden rounded-2xl group">
                <img
                  src={optImg(img, 900)}
                  alt={`Cerimônia ao ar livre ${i + 1}`}
                  className="w-full aspect-[3/4] object-cover transition-transform duration-700 group-hover:scale-105"
                  loading="lazy"
                  data-testid={`outdoor-image-${i}`}
                />
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
